import React, { SVGProps } from 'react';

const SvgCustomChina = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		width='1em'
		height='1em'
		viewBox='0 0 600 600'
		className='svg-icon'
		{...props}>
		<defs>
			<mask id='custom-china_svg__mask0' maskUnits='userSpaceOnUse' x={0} y={0} width={600} height={600}>
				<path
					d='M468.75 0H131.25C58.805 0 0 58.805 0 131.25V468.75C0 541.195 58.805 600 131.25 600H468.75C541.195 600 600 541.195 600 468.75V131.25C600 58.805 541.195 0 468.75 0Z'
					fill='white'
				/>
			</mask>
		</defs>
		<g mask='url(#custom-china_svg__mask0)'>
			<path fill='#EE1C25' d='M0 0h900v600H0' />
			<g transform='matrix(3 0 0 3 150 150)'>
				<path
					id='custom-china_svg__a'
					d='m0-30 17.634 54.27-46.166-33.54h57.064l-46.166 33.54Z'
					fill='#FFDE00'
				/>
			</g>
			<use xlinkHref='#custom-china_svg__a' transform='rotate(23.036 2.784 766.082)' />
			<use xlinkHref='#custom-china_svg__a' transform='rotate(45.87 38.201 485.396)' />
			<use xlinkHref='#custom-china_svg__a' transform='rotate(69.945 29.892 362.328)' />
			<use xlinkHref='#custom-china_svg__a' transform='rotate(20.66 -590.66 957.955)' />
		</g>
	</svg>
);

export default SvgCustomChina;
